import {Player} from "./Player";
import {Monster} from "./Monster";
import {GameConfig} from "../config/GameConfig";
import {FightResult} from "./FightResult";
import {computeCritAttack} from "./Stats";
import {uiBorderColor} from "./Colors";
import {getBarShifts} from "./MonsterBarShifts";

const speedIncreaseTime = 0.75

export class Fight {
    private playerValue: number = 0
    private monsterValue: number = 0
    private fightTime: number = 0
    private fightResult: FightResult = FightResult.IN_PROCESS
    private playerValueBox: Phaser.GameObjects.Graphics
    private monsterValueBox: Phaser.GameObjects.Graphics
    private boxWidth: number = 32
    private boxHeight: number = 2

    constructor(private player: Player, private monster: Monster, private scene: Phaser.Scene) {
        const { width, height } = scene.scale;

        this.playerValueBox = scene.add.graphics();
        this.playerValueBox.setScrollFactor(0);
        this.playerValueBox.setDepth(1000);

        this.monsterValueBox = scene.add.graphics();
        this.monsterValueBox.setScrollFactor(0);
        this.monsterValueBox.setDepth(1000);
        this.fightTime = speedIncreaseTime

        this.drawBoxes();
    }

    private drawBoxes() {
        const { width, height } = this.scene.scale;

        this.playerValueBox.clear();
        this.monsterValueBox.clear();

        const playerBoxX = 84
        const playerBoxY = 40

        this.playerValueBox.lineStyle(2, uiBorderColor);
        this.playerValueBox.strokeRect(playerBoxX, playerBoxY, this.boxWidth, this.boxHeight);

        this.playerValueBox.fillStyle(0xff0000);
        const playerFillWidth = (this.playerValue / GameConfig.fight.targetSpeedValue) * this.boxWidth;
        this.playerValueBox.fillRect(playerBoxX, playerBoxY, playerFillWidth, this.boxHeight);

        const monsterBarShifts = getBarShifts(this.monster.getType())

        const monsterBoxX = width - 130 + monsterBarShifts.speedValueX
        const monsterBoxY = 40 + monsterBarShifts.speedValueY

        this.monsterValueBox.lineStyle(2, uiBorderColor);
        this.monsterValueBox.strokeRect(monsterBoxX, monsterBoxY, this.boxWidth, this.boxHeight);

        this.monsterValueBox.fillStyle(0xff0000);
        const monsterFillWidth = (this.monsterValue / GameConfig.fight.targetSpeedValue) * this.boxWidth;
        this.monsterValueBox.fillRect(monsterBoxX, monsterBoxY, monsterFillWidth, this.boxHeight);
    }

    update(time: number, delta: number) {
        if (this.fightResult !== FightResult.IN_PROCESS) {
            return
        }

        this.fightTime += delta * 0.001

        if (this.fightTime > speedIncreaseTime) {
            this.playerValue += this.player.getStats().speed
            this.monsterValue += this.monster.getStats().speed
            this.fightTime -= speedIncreaseTime
        }

        if (this.playerValue >= GameConfig.fight.targetSpeedValue) {
            this.player.startAttacking()
            this.monster.getStats().health -= computeCritAttack(this.player.getStats())
            this.monster.startDamaging()

            if (this.monster.getStats().health <= 0.0) {
                this.fightResult = FightResult.WIN
                this.player.getStats().gold += this.monster.getStats().gold
            }

            this.playerValue -= GameConfig.fight.targetSpeedValue
        }

        if (this.fightResult === FightResult.IN_PROCESS) {
            if (this.monsterValue >= GameConfig.fight.targetSpeedValue) {
                this.monster.startAttacking()
                this.player.getStats().health -= computeCritAttack(this.monster.getStats())
                this.player.startDamaging()

                if (this.player.getStats().health <= 0.0) {
                    this.fightResult = FightResult.FAIL
                }

                this.monsterValue -= GameConfig.fight.targetSpeedValue
            }
        }

        this.drawBoxes();
        this.monster.update(time, delta)
    }

    getResult(): FightResult {
        return this.fightResult
    }

    public complete() {
        if (this.fightResult === FightResult.WIN) {
            this.monster.dissolve()
            this.monster.destroy()
        }
        else if (this.fightResult === FightResult.FAIL) {
            (this.scene as any).setMonster(this.monster)
        }

        this.playerValueBox.destroy();
        this.monsterValueBox.destroy();
    }
}